import React, { useState } from "react";
import useCoupon from "../useCoupon";

const initialForm = {
  name: "",
  discountRate: "",
  startDate: "",
  endDate: "",
  target: "all",
  maxUses: "",
};

function CreateCoupon({ onSetActiveTab }) {
  const { createCouponFn, isCreatingCoupon, createCouponError } = useCoupon();
  const [form, setForm] = useState(initialForm);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    createCouponFn(
      {
        ...form,
        discountRate: Number(form.discountRate),
        maxUses: Number(form.maxUses),
      },
      {
        onSuccess: () => {
          onSetActiveTab("list");
        },
      }
    );
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="space-y-4 w-full bg-white rounded shadow p-8"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium mb-1">Coupon Name</label>
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Coupon Name"
            className="border p-2 rounded w-full"
            required
          />
        </div>
        {/* <div>
          <label className="block text-sm font-medium mb-1">Target</label>
          <select
            name="target"
            value={form.target}
            onChange={handleChange}
            className="border p-2 rounded w-full"
          >
            <option value="all">All</option>
            <option value="category">Category Only</option>
            <option value="products">Products Only</option>
          </select>
        </div> */}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div>
          <label className="block text-sm font-medium mb-1">
            Discount Rate (%)
          </label>
          <input
            name="discountRate"
            value={form.discountRate}
            onChange={handleChange}
            placeholder="Discount Rate"
            type="number"
            min={1}
            max={100}
            className="border p-2 rounded w-full"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Max Uses</label>
          <input
            name="maxUses"
            value={form.maxUses}
            onChange={handleChange}
            placeholder="Max Uses"
            type="number"
            min={1}
            className="border p-2 rounded w-full"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Start Date</label>
          <input
            name="startDate"
            value={form.startDate}
            onChange={handleChange}
            type="date"
            className="border p-2 rounded w-full"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">End Date</label>
          <input
            name="endDate"
            value={form.endDate}
            onChange={handleChange}
            type="date"
            className="border p-2 rounded w-full"
            required
          />
        </div>
      </div>
      <div className="flex gap-4 mt-8">
        <button
          type="submit"
          disabled={isCreatingCoupon}
          className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition-colors"
        >
          {isCreatingCoupon ? "Creating..." : "Create"}
        </button>
        <button
          type="button"
          onClick={() => onSetActiveTab("list")}
          className="bg-gray-200 text-gray-800 px-6 py-2 rounded hover:bg-gray-300 transition-colors"
        >
          Cancel
        </button>
      </div>
      {createCouponError && (
        <div className="text-red-500 text-center mt-2">
          {createCouponError.message || "Error creating coupon"}
        </div>
      )}
    </form>
  );
}

export default CreateCoupon;
